import firebase from "firebase";
import axios from "axios";
import { STOCK_URL, GALLERY_STOCK_KEY } from "@/consts/gallery-stock-key";

export const GalleryStockPhotosMixin = {
  data() {
    return {
      search: '',
      searchPhotos: [],
      minSearchLength: 3,
      selectedSearchPhotos: [],
      selectedFavouritesPhotos: [],
      collections: [
        'Health',
        'Food',
        'Entertainment',
        'Weather',
        'Sport',
      ],
      pagination: {
        from: 0,
        to: 6,
        current_page: 1,
        per_page: 6,
        total: 0,
        pages: 5,
        max_pages: 10,
        total_visible: 7,
      },
    }
  },
  computed: {
    facility() {
      return this.$store.state.facilityModule.selectedFacility;
    },
    staffUser() {
      return this.$store.state.authModule.user;
    },
    host() {
      return window.location.host;
    }
  },
  methods: {
    async searchPhoto() {
      try {

        const config: any = {
          headers: {
            Authorization: `Client-ID ${GALLERY_STOCK_KEY}`
          }
        }

        await axios.get(
          `${STOCK_URL}/search/photos?page=${this.pagination.current_page}&per_page=${this.pagination.per_page}&query=${this.search}`,
          config
        ).then((response) => {
          this.searchPhotos = response.data.results.map((photo) => {
            return {
              imageId: photo.id,
              image: photo.urls.regular,
              thumbnailUrl: photo.urls.thumb,
              sentBy: `${photo.user.first_name ?? ''} ${photo.user.last_name ?? ''}`,
              alt: photo.alt_description,
              username: photo.user.username,
              downloadImageLink: photo.links.download_location
            }
          });

          this.pagination.pages = this.pagination.max_pages < response.data.total_pages ? this.pagination.max_pages : response.data.total_pages;
        });
      } catch (error) {
        this.$toast.open({
          message: error.message,
          type: "error"
        })
      }
    },
    async addToFavourite() {
      console.log("addToFavourite START")
      for(let i = 0; i < this.selectedSearchPhotos.length; i++) {
        const data = this.selectedSearchPhotos[i];
        const id = String(new Date().getTime());

        try {
          const config: any = {
            headers: {
              Authorization: `Client-ID ${GALLERY_STOCK_KEY}`,
            },
          };

          await axios.get(
            data.downloadImageLink, config
          ).then(async () => {
            console.log("SUCCESSFULLY DOWNLOADED BY THIS LINK");
            console.log(data.downloadImageLink)

            await firebase
              .firestore()
              .collection("photos")
              .doc(id)
              .set(data);
          })
        } catch (error) {
          console.log("error")
          console.log(error)
        }
      }


      await this.getFavouritePhotos();

      this.$toast.open({
        message: this.selectedSearchPhotos.length > 1 ? this.$t("Gallery.ImagesSuccessfullyAdded") : this.$t("Gallery.ImageSuccessfullyAdded"),
        type: "success",
      });

      this.selectedSearchPhotos = [];
    },
    selectSearchPhoto(isSelected, image) {
      if(isSelected) {
        this.selectedSearchPhotos.push({
          createdAt: new Date().getTime(),
          facilityId: this.facility.id,
          image: image.image,
          thumbnailUrl: image.thumbnailUrl,
          imageId: image.imageId,
          isStaff: true,
          isVisibleForStaffGallery: false,
          sentBy: image.sentBy,
          sentById: this.staffUser.id,
          residentId: null,
          isStock: true,
          alt: image.alt,
          username: image.username,
          downloadImageLink: image.downloadImageLink
        })
      } else {
        this.selectedSearchPhotos = this.selectedSearchPhotos.filter(x => x.imageId !== image.imageId)
      }
    },
    selectFavouritesPhotos(isSelected, image) {
      if (isSelected) {
        this.selectedFavouritesPhotos.push({
          id: image.id,
          createdAt: new Date().getTime(),
          facilityId: this.facility.id,
          image: image.image,
          thumbnailUrl: image.thumbnailUrl,
          imageId: image.imageId,
          isStaff: true,
          isVisibleForStaffGallery: false,
          sentBy: image.sentBy,
          sentById: this.staffUser.id,
          residentId: null,
          isStock: true,
          alt: image.alt,
          username: image.username,
          downloadImageLink: image.downloadImageLink
        })
      } else {
        this.selectedFavouritesPhotos = this.selectedFavouritesPhotos.filter(x => x.id !== image.id)
      }
    },
    selectCollection(collection) {
      this.search = collection;
      this.pagination.current_page = 1;
      this.searchPhoto();
    },
    updatePhotos() {
      const result = ((this.pagination.current_page - 1) * this.pagination.per_page);
      this.pagination.from = result;
      this.pagination.to = result + this.pagination.per_page;
      this.searchPhoto();
    },
  },
  watch: {
    search(value, oldValue) {
      if(value.length >= this.minSearchLength) {
        this.searchPhoto();

        if(oldValue.length > value.length) {
          this.pagination.current_page = 1;
        }
      }

      if(value.length === 0 || (value.length > 0 && value[0] !== oldValue[0])) {
        this.pagination.current_page = 1;
      }
    }
  }
}